import React, { useState, useEffect, createRef } from "react";
import loadable from "@loadable/component"
import { Container, Row, Col } from "react-bootstrap";
import GoogleLogo from "../../images/google-logo.png"
import ReviewsBlock from "./ReviewsBlock";
import { ScrollToTop } from "../../common/utils/site_utlis";
//import ReactPaginate from 'react-paginate';

const ReactPaginate = loadable(() => import("react-paginate"));

import "./ClientReview.scss";
const Client = ({ reviewsList, averageRating }) => {
    const myRef = createRef(null);
    const branch = [
        { value: 'All Branches', label: 'All Branches' },
        { value: 'Branches', label: 'Branches' },
    ]

    let [ReviewsBox, setCustomerReview] = useState([]);
    const [reviews, setReviews] = useState([])
    const [pageCount, setPageCount] = useState(0);
    const itemsPerPage = 20;
    const [itemOffset, setItemOffset] = useState(0);

    useEffect(() => { 
        const endOffset = itemOffset + itemsPerPage;
        setPageCount(Math.ceil(reviewsList.length / itemsPerPage));
        setReviews(reviewsList.slice(itemOffset, endOffset)); 
    }, [itemOffset, reviewsList]);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % reviewsList.length;
        setItemOffset(newOffset);
        ScrollToTop(myRef.current, 1000)
    };
   


    return (
        <React.Fragment>
            <section className="client-reviews" ref={myRef}>
                <Container>
                    <Row>
                        <Col>
                            <div className="review-wrapper">
                                <h3>Real reviews from real people</h3>
                                <div className="content-wrap">
                                    <img src={GoogleLogo} alt="google" />
                                    <strong> {averageRating}/5</strong>
                                    <span>from {reviewsList?.length} customer reviews</span>
                                </div>
                                {/* <div className="select">
                                    <Select options={branch} placeholder="All Branches" className="react-select"
                                        classNamePrefix="react-select" />
                                </div> */}
                            </div> 
                            <div className="review-box-wrapper"> 
                                {reviews.map((review, index) => (
                                    <ReviewsBlock key={index} ReviewsList={review} />
                                ))}
                            </div>
                            {/* <Pagination /> */}

                            {pageCount > 1 &&
                                <div className="pagination-section">
                                    <ReactPaginate
                                        breakLabel="..."
                                        nextLabel="next >"
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={5}
                                        pageCount={pageCount}
                                        previousLabel="< previous"
                                        renderOnZeroPageCount={null}
                                        className="pagination"
                                        pageClassName="page-item"
                                        pageLinkClassName="page-link"
                                        previousClassName="prev page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="next page-item"
                                        nextLinkClassName="page-link"
                                        activeClassName="active"
                                    />
                                </div>
                            }

                        </Col>
                    </Row>


                </Container>
            </section>
        </React.Fragment>
    );
};
export default Client;
